module.exports = __webpack_public_path__ + "img/paternoster-08.b18bf797.jpg";